import * as React from "react";

function SvgPlayOutline(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34" {...props}><path d="M17 34C7.6 34 0 26.4 0 17S7.6 0 17 0s17 7.6 17 17-7.6 17-17 17zm0-32C8.7 2 2 8.7 2 17s6.7 15 15 15 15-6.7 15-15S25.3 2 17 2z" /><path d="M12 25.7V8.3L27 17l-15 8.7zm2-14v10.5l9-5.3-9-5.2z" /></svg>;
}

export default SvgPlayOutline;